import React, { useState, useEffect } from "react";
import DropdownFilter from "../customFilters/DropdownFilter";
import SearchBar from "../SearchBar";
import Placeholder from 'react-bootstrap/Placeholder';
import Col from 'react-bootstrap/Col';
import {extractHeader} from '../../utils/utilsHelpers';
import {objectMap} from "../../../javascripts/utils";

export default function Filters(props) {

    useEffect(() => {

    });

    const isCheckedHandler = (filterName, item, type) => {
        return !!(props.selectedFilters[type] && Object.keys(props.selectedFilters[type]).includes(filterName) && props.selectedFilters[type][filterName].includes(item));
    }

    const renderFilters = () => {
        if (!props.filtersMapping.dropdown) {
            return;
        }

        if(props.asCheckboxes) {
            return (
                objectMap(props.filtersMapping.dropdown, (filterOptions, filterName) => {
                    if(filterOptions.length) {
                        return (
                            <DropdownFilter
                                index={filterName}
                                onItemSelect={props.onFilterSelect}
                                filterName={filterName}
                                filters={props.filtersMapping.dropdown}
                                isCheckedHandler={isCheckedHandler}
                                defaultOpen={props.defaultOpen == filterName}
                                key={filterName}
                                dropdownCheckBoxes={true}
                                onToggleHandler={props.onFilterToggleHandler}
                            />
                        )
                    }
                })
            )
        } else {
            return (
                <>
                    {objectMap(props.filtersMapping.dropdown, (filterOptions, filterName) => {
                        if(filterOptions.length) {
                            return (
                                <Col sm={12} md={4} key={`filter-${filterName}`}>
                                    <div className={'text-secondary content-styling fs-6'}>{extractHeader(filterName)}</div>
                                    <DropdownFilter
                                        index={filterName}
                                        onItemSelect={props.onFilterSelect}
                                        filterName={filterName}
                                        filters={props.filtersMapping.dropdown}
                                        isCheckedHandler={isCheckedHandler}
                                        defaultOpen={false}
                                        key={filterName}
                                        dropdownCheckBoxes={false}
                                        gtmEventRegion={props.gtmEventRegion}
                                    />
                                </Col>
                            )
                        }
                    })}
                </>
            )
        }
    }

    const renderSearchField = () => {
        if(props.showSearchField) {
            return (
                <SearchBar
                    onSearchChange={props.onSearchChange}
                />
            )
        }
    }

    const renderFilterPlaceholder = () => {
        if(props.showPlaceholder) {
            return (
                <>
                    {[...Array(6).keys()].map( (k) => {
                        return (
                            <Placeholder as={'p'} animation={'glow'} key={`placeholder-${k}`} className={'py-2 m-0'}>
                                <Placeholder xs={12} style={{height: '24px'}} />
                            </Placeholder>
                        )
                    })}
                </>
            )
        }
    }

    if(!props.asCheckboxes && props.data.length) {
        return (
            <>
                {props.filtersMapping.dropdown && renderFilters() }
            </>
        )
    } else if(props.data.length || props.showSearchField) {
        return (
            <div className={'card-box'} style={{display: 'flow-root'}}>
                {props.showColumnHdr && <h4 className={'header-title mt-1 mb-3'}>{props.filterHeader}</h4>}
                {renderSearchField()}
                {props.filtersMapping.dropdown ? renderFilters() : renderFilterPlaceholder()}
            </div>
        )
    } else {
        return <></>
    }

}